




















import { Component, Vue, Prop } from "vue-property-decorator"
import shareDialog from "@/components/shareDialog"
import downloadDialog from "@/components/downloadDialog"

import { appBoundle } from "@/utils/base"
const { openApp } = appBoundle()

@Component({
  name: "CommentInput"
})
export default class CommentInput extends Vue {
  handleDownload() {
    openApp(window._launchAppUrl, function() {
      downloadDialog(
        {
          rmAfterDestroy: false,
          presetData: {}
        },
        () => {}
      )
    })
  }

  handleShare() {
    shareDialog(
      {
        rmAfterDestroy: false,
        presetData: {}
      },
      () => {}
    )
  }
}
